<app-header [showToggle]="false" [showSignin]="false"></app-header>
<main id="main" class="main">

  <section class="section dashboard">
    <div class="pagetitle text-center" *ngIf="!isErrorPage">
      <h1>Signin</h1>
      <div class="div-page-description">
        <h5>
          Please proceed by signing in with your Google Search Console account that you use to manage your websites.
        </h5>
      </div>
    </div>

    <div class="container mt-5" style="margin-bottom:400px">

      <div class="row" *ngIf="isErrorPage">

        <div class="col-md-3"></div>
        <div class="col-md-6">

          <div class="card">
            <div class="card-body">
              <h4 class="text-center fw-bold mt-4">Permission Issue</h4>
              <p>Oops, it seems like we don't have the right permission to access your Google Search Console info. Here are two reasons why:</p>
              <p>
                <b>1. Permissions Not Given:</b><br />
                When you logged in, <u>you forgot to let us see your Search Console sites</u>. To fix this, log in again and grant access <span class="text-primary cursor-pointer" (click)="signInWithGoogle()">here</span>.
              </p>
              <p class="text-center">
                <img src="../../assets/img/allow access.png" alt="allow access" class="img-fluid">
              </p>
              <p>
                <b>2. Problem with Authentication:</b><br />
                Go to your Google security settings and remove the connection with Rank Ahead at <a href="https://myaccount.google.com/connections" target="_blank">https://myaccount.google.com/connections</a>. Then, log out and log back in to get new tokens.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3"></div>
      </div>
      <div class="row" *ngIf="!isErrorPage">

        <div class="col-md-4"></div>
        <div class="col-md-4 text-center">

          <button (click)="signInWithGoogle()" type="button" class="login-with-google-btn">Sign in with Google</button>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>
  </section>
</main>

<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
<app-alert [showMessage]="showMessage" [message]="message" [alertType]="alertType">
</app-alert>
